// ワークフロー用文書種別
export enum WorkflowDocumentKinds {
  None = 0,
  RequestSheet = 1,
  Document = 2,
}
